import { FiltersPlugin } from "@me8eon/filters/src/filters.plugin";
import { SimpleDisplayMimeTypeFilter } from "./simple.mime.type";


export const mimeTypeFilterPluginName = "mimeType";


export type MimeTypeString = keyof typeof mimeTypeToGraphApiQueryString
export const mimeTypeToGraphApiQueryString = {
    'powerpoint': '(filetype:ppt OR filetype:pptx)',
    'word': '(filetype:docx OR filetype:doc)',
    'excel': '(filetype:xlsx OR filetype:xls)',
    'pdf': 'filetype:pdf',
    'loop': 'filetype:loop',
    'other': 'NOT (filetype:ppt OR filetype:pptx OR filetype:docx OR filetype:doc OR filetype:xlsx OR filetype:xls OR filetype:pdf OR filetype:loop)',
};
export const mimeTypeIconMap: Record<MimeTypeString, string> = {
    powerpoint: "pptx",
    word: "docx",
    excel: "xlsx",
    pdf: "pdf",
    loop: "loop",
    other: "genericfile",
};
export const mimeTypeExtensionMap = {
    pptx: "powerpoint",
    ppt: "powerpoint",
    docx: "word",
    doc: "word",
    xlsx: "excel",
    xls: "excel",
    loop: "loop",
    pdf: "pdf",
};

export const mimeTypeStrings: MimeTypeString[] = Object.keys(mimeTypeIconMap) as MimeTypeString[];

export type MimeTypeFilters = {
    [mimeTypeFilterPluginName]: MimeTypeString
}


export const mimeTypeFilterPlugin: FiltersPlugin<MimeTypeFilters, "mimeType"> = {
    plugin: "filter",
    type: mimeTypeFilterPluginName,
    changeCausesSubmit: true,
    deleteWhenClean: true,
    DefaultDisplay: SimpleDisplayMimeTypeFilter,
};